<template lang='pug'>
.row.tags
  .col-xs-12.tags-inner-container
    b(v-text='"MORE"')
    ul
      li(v-for='tag, index in tags' :key='index')
        router-link(:to='tagPath(tag)' v-text='`${tag.attributes.name.toUpperCase()}`' @click.native='setSelectedTag(tag)')
</template>
<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      tags: state => state.beautyFeedShow.tags
    })
  },
  methods: {
    setSelectedTag (tag) {
      this.$store.commit('beautyFeed/setSelectedTag', tag.attributes.name)
    },
    tagPath (tag) {
      return { name: 'beautyfeed-tag', params: { slug: tag.attributes.slug } }
    }
  }
}
</script>

<style lang='scss' scoped>
.tags {
  font-size: 16px;
  letter-spacing: 0.3px;
  line-height: 20px;

  b {
    margin-right: 15px;
  }

  ul {
    display: flex;
    flex-wrap: wrap;

    li {
      margin-right: 15px;
      a {
        text-decoration: underline;
        cursor: pointer;
      }
    }
  }
}

.tags-inner-container {
  display: flex;
  padding: 20px 40px;

  @media (min-width: 768px) {
    padding: 20px 15px;
  }
}
</style>
